import { render, staticRenderFns } from "./apply-info.vue?vue&type=template&id=96d1169e&scoped=true&"
import script from "./apply-info.vue?vue&type=script&lang=js&"
export * from "./apply-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d1169e",
  null
  
)

export default component.exports